import { render } from "./Delcode2.vue?vue&type=template&id=1849f87a&scoped=true"
import script from "./Delcode2.vue?vue&type=script&lang=js"
export * from "./Delcode2.vue?vue&type=script&lang=js"

import "./Delcode2.vue?vue&type=style&index=0&id=1849f87a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1849f87a"]])

export default __exports__